/**
 * Single product functionality.
 */

import imagesLoaded from 'imagesloaded';
import 'flickity/css/flickity.css';
import Flickity from 'flickity';
import stickybits from 'stickybits';

jQuery( $ => {
	// flickity-as-nav-for is added as a require because for some dumb reason the build process on synotio wont work otherwise.
	require( 'flickity-as-nav-for' );

	// Save the original product price html so it can be reset.
	const originalPrice = $( '.summary-inner-wrapper > .price' ).html();

	/**
	 * Single product images as a slider.
	 */
	if ( 0 < $( '.product-image-slider' ).length ) {
		new imagesLoaded( $( '.product-images-slider-container' ), { background: true }, () => {
			const productImagesOptions = {
				prevNextButtons: false,
				dragThreshold: 10,
			};
			new Flickity( $( '.product-image-slider' )[ 0 ], productImagesOptions );

			// Setup the thumbnails navigation.
			const productThumbnailsOptions = {
				asNavFor: '.product-image-slider',
				pageDots: false,
				draggable: false,
				percentPosition: false,
				groupCells: true,
				cellAlign: 'left',
				prevNextButtons: false,
			};
			// If there's more than 6 thumbnails we need navigation!
			if ( 6 < $( '.product-images-slider-thumbnails-slide .product-images-slider-item-thumb' ).length ) {
				productThumbnailsOptions.prevNextButtons = true;
			}
			new Flickity( $( '.product-images-slider-thumbnails-slide' )[ 0 ], productThumbnailsOptions );
		} );
	}

	/**
	 * Flickity slider for reference pages
	 */
	if ( 0 < $( '.main-carousel' ).length ) {
		new imagesLoaded( $( '.main-carousel' ), { background: true }, () => {
			const productThumbnailsOptions2 = {
				wrapAround: true,
			};

			new Flickity( $( '.main-carousel' )[ 0 ], productThumbnailsOptions2 );
		} );
	}

	if ( 0 < $( '.carousel-only-mobile' ).length ) {
		new imagesLoaded( $( '.carousel-only-mobile' ), { background: true }, () => {
			const productThumbnailsOptions2 = {
				watchCSS: true,
				freeScroll: true,
				contain: true,
				prevNextButtons: false,
				pageDots: false,
			};

			new Flickity( $( '.carousel-only-mobile' )[ 0 ], productThumbnailsOptions2 );
		} );
	}

	/**
	 * Summary as a sticky container on scroll.
	 * Source: https://github.com/dollarshaveclub/stickybits
	 */
	stickybits( '.product .entry-summary', {
		useStickyClasses: true,
	} );

	/**
	 * Trigger accordion.
	 */
	$( '.product-block-content h2' ).click( function() {
		const parentEl = $( this ).closest( '.product-block' );
		toggleProductBlock( parentEl );
	} );

	/**
	 * Toggle the description block
	 */
	$( '.product-meta-link-info a' ).click( function() {
		const target = $( this ).attr( 'href' );
		const blockEl = $( target );
		toggleProductBlock( blockEl, true );
	} );

	/**
	 * Toggles a product blocks accordion.
	 *
	 * @param {Object}  blockEl   the outer block element.
	 * @param {boolean} forceOpen wether it should be forced to open.
	 */
	function toggleProductBlock( blockEl, forceOpen = false ) {
		const trigger = blockEl.find( 'h2' );
		const content = blockEl.find( '.product-block-inner-content' );

		if ( forceOpen ) {
			blockEl.removeClass( 'accordion-hidden' );
			trigger.attr( 'aria-expanded', 'true' );
			content.attr( 'aria-hidden', 'false' );
			return;
		}
		// Toggle class for the block which sets visibility.
		blockEl.toggleClass( 'accordion-hidden' );
		// Aria for the h2 trigger element.
		trigger.attr( 'aria-expanded', ( i, attr ) => {
			return 'true' === attr ? 'false' : 'true';
		} );
		// Aria for the hidden content.
		content.attr( 'aria-hidden', ( i, attr ) => {
			return 'true' === attr ? 'false' : 'true';
		} );
	}

	/**
	 * Make changes to the page whenever a change in the variations occurs.
	 * Show variation selection along with the label.
	 * Show the variations price instead of the price range.
	 *
	 */
	$( '.variations select' ).change( function() {
		const select = $( this );
		addSelectedVariationToLabel( select );
		setTimeout( setVariationPricing, 200 );
	} ).change();

	/**
	 * Appends the value for the variation to the label.
	 *
	 * @param {Object} select variation select.
	 */
	function addSelectedVariationToLabel( select ) {
		const labelEl = select.parent( 'td' ).siblings( '.label' );
		const labelValue = select.children( 'option:selected' ).text();
		// If the label value element already exists we just change it's text.
		if ( 0 < labelEl.children( '.label-value' ).length ) {
			labelEl.children( '.label-value' ).text( ': ' + labelValue );
			return;
		}
		labelEl.append( '<span class="label-value">: ' + labelValue + '</span>' );
	}

	/**
	 * Changes the price displayed to that of the chosen variation.
	 */
	function setVariationPricing() {
		const variationId = $( 'input[name="variation_id"]' ).val();
		const priceEl = $( '.summary-inner-wrapper > .price' );

		// No variation selected means we want to reset the product price html and bail.
		if ( undefined === variationId || 0 === parseInt( variationId ) || '' === variationId ) {
			priceEl.html( originalPrice );
			return;
		}

		// Get the variation price and overwrite the range pricing html.
		const variationPrice = $( '.woocommerce-variation-price .price' ).html();
		priceEl.html( variationPrice );
	}
} );
